import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FeatureTaxIncomeDetailsComponent } from './tax-income-details/feature-tax-income-details.component';
import { SharedUiIconModule } from '@snelstart/ui-icon';
import { AangeverComponent } from './income/persoonlijk/aangever/aangever.component';
import { PartnerComponent } from './income/persoonlijk/partner/partner.component';
import { KindComponent } from './income/persoonlijk/kind/kind.component';
import { RelatiegegevensComponent } from './income/persoonlijk/relatiegegevens/relatiegegevens.component';
import { ApvLijstComponent } from './income/apv-lijst/apv-lijst.component';
import {
    Box1BelastbareInkomstenOpBasisVanOvergangsrechtComponent
} from './income/box1/box1-belastbare-inkomsten-op-basis-van-overgangsrecht/box1-belastbare-inkomsten-op-basis-van-overgangsrecht.component';
import {
    Box1NegatievePersoonsgebondenAftrekComponent
} from './income/box1/box1-negatieve-persoonsgebonden-aftrek/box1-negatieve-persoonsgebonden-aftrek.component';
import {
    Box1NegatieveUitgavenVoorInkomensvoorzieningenComponent
} from './income/box1/box1-negatieve-uitgaven-voor-inkomensvoorzieningen/box1-negatieve-uitgaven-voor-inkomensvoorzieningen.component';
import {
    Box2InkomenUitAanmerkelijkBelangComponent
} from './income/box2/box2-inkomen-uit-aanmerkelijk-belang/box2-inkomen-uit-aanmerkelijk-belang.component';
import { Box3OwrComponent } from './income/box3/box3-owr/box3-owr.component';
import { Box3BankrekeningenComponent } from './income/box3/box3-bankrekeningen/box3-bankrekeningen.component';
import {
    Box3BeleggingsrekeningenComponent
} from './income/box3/box3-beleggingsrekeningen/box3-beleggingsrekeningen.component';
import { Box3LeningenComponent } from './income/box3/box3-leningen/box3-leningen.component';
import {
    Box3NietVrijgesteldeKapitaalverzekeringenComponent
} from './income/box3/box3-niet-vrijgestelde-kapitaalverzekeringen/box3-niet-vrijgestelde-kapitaalverzekeringen.component';
import {
    Box3OverigeBezittingenComponent
} from './income/box3/box3-overige-bezittingen/box3-overige-bezittingen.component';
import {
    Box3OverigeOnroerendeZakenComponent
} from './income/box3/box3-overige-onroerende-zaken/box3-overige-onroerende-zaken.component';
import {
    Box3OverigePeriodiekeUitkeringenComponent
} from './income/box3/box3-overige-periodieke-uitkeringen/box3-overige-periodieke-uitkeringen.component';
import {
    Box3VorderingenOfContantGeldComponent
} from './income/box3/box3-vorderingen-of-contant-geld/box3-vorderingen-of-contant-geld.component';
import { ConserverendInkomenComponent } from './income/conserverend-inkomen/conserverend-inkomen.component';
import { HeffingskortingenComponent } from './income/heffingskortingen/heffingskortingen.component';
import {
    PgaOnderhoudsverplichtingenComponent
} from './income/persoonsgebonden-aftrek/pga-onderhoudsverplichtingen/pga-onderhoudsverplichtingen.component';
import {
    PgaRestantPgaVoorgaandeJarenComponent
} from './income/persoonsgebonden-aftrek/pga-restant-pga-voorgaande-jaren/pga-restant-pga-voorgaande-jaren.component';
import {
    PgaScholingsuitgavenComponent
} from './income/persoonsgebonden-aftrek/pga-scholingsuitgaven/pga-scholingsuitgaven.component';
import {
    PgaSpecifiekeZorgkostenComponent
} from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/pga-specifieke-zorgkosten.component';
import {
    PgaWeekenduitgavenGehandicapteKinderenComponent
} from './income/persoonsgebonden-aftrek/pga-weekenduitgaven-gehandicapte-kinderen/pga-weekenduitgaven-gehandicapte-kinderen.component';
import { PremieplichtComponent } from './income/premieplicht/premieplicht.component';
import { VerdelingComponent } from './income/verdeling/verdeling.component';
import { VertegenwoordigerComponent } from './income/vertegenwoordiger/vertegenwoordiger.component';
import { VoorheffingenComponent } from './income/voorheffingen/voorheffingen.component';
import { LoonBuitenlandComponent } from './income/box1/box1-belastbaar-loon/loon-buitenland/loon-buitenland.component';
import {
    LoonInternationaleOrganisatieComponent
} from './income/box1/box1-belastbaar-loon/loon-internationale-organisatie/loon-internationale-organisatie.component';
import {
    LoonTegenwoordigComponent
} from './income/box1/box1-belastbaar-loon/loon-tegenwoordig/loon-tegenwoordig.component';
import { LoonVroegerComponent } from './income/box1/box1-belastbaar-loon/loon-vroeger/loon-vroeger.component';
import { ReisaftrekOvComponent } from './income/box1/box1-belastbaar-loon/reisaftrek-ov/reisaftrek-ov.component';
import {
    EigenwoningRestschuldenComponent
} from './income/box1/box1-belastbare-inkomsten-uit-eigenwoning/eigenwoning-restschulden/eigenwoning-restschulden.component';
import {
    EigenwoningSchuldenComponent
} from './income/box1/box1-belastbare-inkomsten-uit-eigenwoning/eigenwoning-schulden/eigenwoning-schulden.component';
import {
    EigenwoningenComponent
} from './income/box1/box1-belastbare-inkomsten-uit-eigenwoning/eigenwoningen/eigenwoningen.component';
import {
    AlimentatieComponent
} from './income/box1/box1-belastbare-periodieke-uitkeringen-en-verstrekkingen/alimentatie/alimentatie.component';
import {
    PeriodiekeUitkeringenComponent
} from './income/box1/box1-belastbare-periodieke-uitkeringen-en-verstrekkingen/periodieke-uitkeringen/periodieke-uitkeringen.component';
import {
    TbsRegelingComponent
} from './income/box1/box1-resultaat-overige-werkzaamheden/tbs-regeling/tbs-regeling.component';
import {
    ResultaatUitOverigeWerkzaamhedenComponent
} from './income/box1/box1-resultaat-overige-werkzaamheden/resultaat-uit-overige-werkzaamheden/resultaat-uit-overige-werkzaamheden.component';
import {
    OverigePremiesComponent
} from './income/box1/box1-uitgaven-voor-inkomensvoorzieningen/overige-premies/overige-premies.component';
import { OndernemerComponent } from './income/box1/box1-winst-uit-onderneming/ondernemer/ondernemer.component';
import { SharedUiOffCanvasModule } from '@snelstart/ui-off-canvas';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import {
    GewoneGiftenComponent
} from './income/persoonsgebonden-aftrek/pga-aftrekbare-giften/gewone-giften/gewone-giften.component';
import {
    PeriodiekeGiftenComponent
} from './income/persoonsgebonden-aftrek/pga-aftrekbare-giften/periodieke-giften/periodieke-giften.component';
import {
    BehandelkostenComponent
} from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/behandelkosten/behandelkosten.component';
import { DietenComponent } from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/dieten/dieten.component';
import {
    ExtraUitgavenKledingEnBeddengoedComponent
} from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/extra-uitgaven-kleding-en-beddengoed/extra-uitgaven-kleding-en-beddengoed.component';
import {
    HulpmiddelenComponent
} from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/hulpmiddelen/hulpmiddelen.component';
import {
    KostenExtraGezinshulpComponent
} from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/kosten-extra-gezinshulp/kosten-extra-gezinshulp.component';
import {
    MedicijnenComponent
} from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/medicijnen/medicijnen.component';
import {
    ReiskostenEigenZorgComponent
} from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/reiskosten-eigen-zorg/reiskosten-eigen-zorg.component';
import {
    ReiskostenZorgGezinslidComponent
} from './income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/reiskosten-zorg-gezinslid/reiskosten-zorg-gezinslid.component';
import { Box1BelastbaarLoonComponent } from './income/box1/box1-belastbaar-loon/box1-belastbaar-loon.component';
import {
    Box1ResultaatOverigeWerkzaamhedenComponent
} from './income/box1/box1-resultaat-overige-werkzaamheden/box1-resultaat-overige-werkzaamheden.component';
import {
    Box1BelastbarePeriodiekeUitkeringenEnVerstrekkingenComponent
} from './income/box1/box1-belastbare-periodieke-uitkeringen-en-verstrekkingen/box1-belastbare-periodieke-uitkeringen-en-verstrekkingen.component';
import {
    Box1UitgavenVoorInkomensvoorzieningenComponent
} from './income/box1/box1-uitgaven-voor-inkomensvoorzieningen/box1-uitgaven-voor-inkomensvoorzieningen.component';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import {
    Box1WinstUitOndernemingComponent
} from './income/box1/box1-winst-uit-onderneming/box1-winst-uit-onderneming.component';
import { SharedFeatureNavigationBarModule } from '@snelstart/feature-navigation-bar';
import { SharedUiTabModule } from '@snelstart/ui-tab';
import { Box3SparenEnBeleggenComponent } from './income/box3/box3-sparen-en-beleggen/box3-sparen-en-beleggen.component';
import { SharedUiTitleBarModule } from '@snelstart/ui-title-bar';
import { Box3Component } from './income/box3/box3.component';
import {
    PgaAftrekbareGiftenComponent
} from './income/persoonsgebonden-aftrek/pga-aftrekbare-giften/pga-aftrekbare-giften.component';
import {
    SpecZorgkostenComponent
} from './income/persoonsgebonden-aftrek/pga-samenvatting/spec-zorgkosten/spec-zorgkosten.component';
import {
    SpecScholingComponent
} from './income/persoonsgebonden-aftrek/pga-samenvatting/spec-scholing/spec-scholing.component';
import {
    SpecGiftenComponent
} from './income/persoonsgebonden-aftrek/pga-samenvatting/spec-giften/spec-giften.component';
import {
    SpecOverigePgaComponent
} from './income/persoonsgebonden-aftrek/pga-samenvatting/spec-overige-pga/spec-overige-pga.component';

import {
    StudiefinancieringComponent
} from './income/persoonsgebonden-aftrek/pga-scholingsuitgaven/studiefinanciering/studiefinanciering.component';
import {
    StudiefinancieringAangeverComponent
} from './income/persoonsgebonden-aftrek/pga-scholingsuitgaven/studiefinanciering/studiefinanciering-aangever/studiefinanciering-aangever.component';
import { AanvullendeVragenComponent } from './income/aanvullende-vragen/aanvullende-vragen.component';
import { IackInfoComponent } from './income/aanvullende-vragen/iack-info/iack-info.component';
import { AanslagenComponent } from './income/aanslagen/aanslagen.component';
import { SharedUiMainModule } from '@snelstart/ui-main';
import { SharedUiTableModule } from '@snelstart/ui-table';
import {
    DividendbelastingBox2Component
} from './income/voorheffingen/dividendbelasting-box2/dividendbelasting-box2.component';
import {
    DividendbelastingBox3Component
} from './income/voorheffingen/dividendbelasting-box3/dividendbelasting-box3.component';
import {
    LoonOnderdeelWinstComponent
} from './income/voorheffingen/loon-onderdeel-winst/loon-onderdeel-winst.component';
import {
    BuitenlandseBronheffingTotaalComponent
} from './income/voorheffingen/buitenlandse-bronheffing-totaal/buitenlandse-bronheffing-totaal.component';
import { AlgemeenComponent } from './income/box1/box1-winst-uit-onderneming/onderneming/algemeen/algemeen.component';
import { BalansComponent } from './income/box1/box1-winst-uit-onderneming/onderneming/balans/balans.component';
import {
    InvesteringenComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/investeringen/investeringen.component';
import {
    WinstEnVerliesComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/winst-en-verlies/winst-en-verlies.component';
import { RapportComponent } from './income/overzicht/rapport.component';
import { SharedUiTooltipModule } from '@snelstart/ui-tooltip';
import { SharedUiModule } from '@snelstart/ui';
import {
    Box1BelastbareInkomstenUitEigenwoningComponent
} from './income/box1/box1-belastbare-inkomsten-uit-eigenwoning/box1-belastbare-inkomsten-uit-eigenwoning.component';
import { FeatureTaxAllowanceListModule } from '@snelstart-ventures/fiscaal/feature-tax-allowance-list';
import { FeatureTaxAllowanceDetailsModule } from '@snelstart-ventures/fiscaal/feature-tax-allowance-details';
import { SharedUiLoadingModule } from '@snelstart/ui-loading';

import { SharedUiAlertModule } from '@snelstart/ui-alert';
import {
    HeffingskortingenBerekeningenComponent
} from './income/berekeningen/heffingskortingen/heffingskortingen.component';
import {
    PersoonsgebondenAftrekBerekeningenComponent
} from './income/berekeningen/persoonsgebonden-aftrek/persoonsgebonden-aftrek.component';
import { OverzichtLoonComponent } from './income/overzicht/box1/overzicht-loon/overzicht-loon.component';
import {
    OverzichtResultaatOverigeWerkzaamhedenComponent
} from './income/overzicht/box1/overzicht-resultaat-overige-werkzaamheden/overzicht-resultaat-overige-werkzaamheden.component';
import {
    OverzichtPeriodiekeUitkeringenComponent
} from './income/overzicht/box1/overzicht-periodieke-uitkeringen/overzicht-periodieke-uitkeringen.component';
import {
    OverzichtEigenWoningComponent
} from './income/overzicht/box1/overzicht-eigen-woning/overzicht-eigen-woning.component';
import { OverzichtLijfrenteComponent } from './income/overzicht/box1/overzicht-lijfrente/overzicht-lijfrente.component';
import {
    OverzichtWinstUitOndernemingComponent
} from './income/overzicht/box1/wuo/overzicht-winst-uit-onderneming/overzicht-winst-uit-onderneming.component';
import {
    OverzichtJaarrekeningComponent
} from './income/overzicht/box1/wuo/overzicht-jaarrekening/overzicht-jaarrekening.component';
import {
    OverzichtVerliescompensatieBox1Component
} from './income/overzicht/box1/overzicht-verliescompensatie-box1/overzicht-verliescompensatie-box1.component';
import {
    SpecPartnerschapComponent
} from './income/overzicht/persoonlijk/spec-partnerschap/spec-partnerschap.component';
import {
    OverzichtInkomenBox1Component
} from './income/overzicht/box1/overzicht-inkomen-box1/overzicht-inkomen-box1.component';
import {
    OverzichtInkomenBox2Component
} from './income/overzicht/box2/overzicht-inkomen-box2/overzicht-inkomen-box2.component';
import {
    OverzichtInkomenBox3Component
} from './income/overzicht/box3/overzicht-inkomen-box3/overzicht-inkomen-box3.component';
import {
    SpecBelastingBox3Component
} from './income/berekeningen/inkomstenbelasting/spec-belasting-box3/spec-belasting-box3.component';
import {
    SpecBelastingBox2Component
} from './income/berekeningen/inkomstenbelasting/spec-belasting-box2/spec-belasting-box2.component';
import {
    SpecBelastingBox1Component
} from './income/berekeningen/inkomstenbelasting/spec-belasting-box1/spec-belasting-box1.component';
import {
    SpecPremieVolksverzekeringenComponent
} from './income/berekeningen/premie-volksverzekeringen/spec-premie-volksverzekeringen/spec-premie-volksverzekeringen.component';
import {
    SpecHeffingskortingenComponent
} from './income/overzicht/heffingskortingen/spec-heffingskortingen/spec-heffingskortingen.component';
import {
    SpecVoorheffingenComponent
} from './income/overzicht/voorheffingen/spec-voorheffingen/spec-voorheffingen.component';
import { SharedUiEntityHeaderModule } from '@snelstart/ui-entity-header';
import { UitlegAanslagComponent } from './income/berekeningen/uitleg-aanslag/uitleg-aanslag.component';
import { SharedUiPanelModule } from '@snelstart/ui-panel';
import {
    PremiesAovComponent
} from './income/box1/box1-uitgaven-voor-inkomensvoorzieningen/overige-premies/premies-aov/premies-aov.component';
import {
    PremiesAnwComponent
} from './income/box1/box1-uitgaven-voor-inkomensvoorzieningen/overige-premies/premies-anw/premies-anw.component';
import {
    PremiesKindComponent
} from './income/box1/box1-uitgaven-voor-inkomensvoorzieningen/overige-premies/premies-kind/premies-kind.component';
import {
    LijfrenteComponent
} from './income/box1/box1-uitgaven-voor-inkomensvoorzieningen/lijfrente/lijfrente.component';
import {
    LijfrentePremiesComponent
} from './income/box1/box1-uitgaven-voor-inkomensvoorzieningen/lijfrente/lijfrente-premies/lijfrente-premies.component';
import {
    JaarruimtegegevensComponent
} from './income/box1/box1-uitgaven-voor-inkomensvoorzieningen/lijfrente/jaarruimtegegevens/jaarruimtegegevens.component';
import {
    BalansActivaComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/balans-activa/balans-activa.component';
import {
    BalansPassivaComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/balans-passiva/balans-passiva.component';
import {
    SpecOmzetbelastingActivaComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-omzetbelasting-activa/spec-omzetbelasting-activa.component';
import {
    SpecHirComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-hir/spec-hir.component';
import {
    SpecForComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-for/spec-for.component';
import {
    SpecGebouwenEigenComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-gebouwen-eigen/spec-gebouwen-eigen.component';
import {
    SpecGebouwenDerdenComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-gebouwen-derden/spec-gebouwen-derden.component';
import {
    SpecOmzetbelastingPassivaComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-omzetbelasting-passiva/spec-omzetbelasting-passiva.component';
import {
    AdministratieKoppelenIbComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/administratie-koppelen-ib/administratie-koppelen.component-ib';
import {
    VermogensvergelijkingComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/vermogensvergelijking/vermogensvergelijking.component';
import {
    WinstcorrectiesComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/winstcorrecties/winstcorrecties.component';
import {
    VragenVoorafOndComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/vragen-vooraf-ond/vragen-vooraf-ond.component';
import {
    PriveOntrekkingenEnStortingenComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/prive-ontrekkingen-en-stortingen/prive-ontrekkingen-en-stortingen.component';
import {
    SpecEgalisatiereserveComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-egalisatiereserve/spec-egalisatiereserve.component';
import { SharedUiTooltipTriggerModule } from '@snelstart/ui-tooltip-trigger';
import {
    SpecGarantievoorzieningComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-garantievoorziening/spec-garantievoorziening.component';
import {
    VoorlopigeAanslagenComponent
} from './income/voorheffingen/voorlopige-aanslagen/voorlopige-aanslagen.component';
import { DividendbelastingComponent } from './income/voorheffingen/dividendbelasting/dividendbelasting.component';
import {
    VerrekenbareVerliezenComponent
} from './income/aanvullende-vragen/verrekenbare-verliezen/verrekenbare-verliezen.component';
import {
    HuurinkomstenComponent
} from './income/box1/box1-belastbare-inkomsten-uit-eigenwoning/huurinkomsten/huurinkomsten.component';
import {
    OverigEigenWoningComponent
} from './income/box1/box1-belastbare-inkomsten-uit-eigenwoning/overig-eigen-woning/overig-eigen-woning.component';
import {
    FinancieringskostenComponent
} from './income/box1/box1-belastbare-inkomsten-uit-eigenwoning/financieringskosten/financieringskosten.component';
import {
    MeerBanenTegelijkComponent
} from './income/box1/box1-belastbaar-loon/meer-banen-tegelijk/meer-banen-tegelijk.component';
import {
    OnverrekendeBuitenlandseBronheffingComponent
} from './income/voorheffingen/onverrekende-buitenlandse-bronheffing/onverrekende-buitenlandse-bronheffing.component';
import { InkomstenbelastingComponent } from './income/berekeningen/inkomstenbelasting/inkomstenbelasting.component';
import { ZorgverzekeringswetComponent } from './income/berekeningen/zorgverzekeringswet/zorgverzekeringswet.component';

import {
    TekstPersoonlijkAangeverComponent
} from './income/toelichtingen-tekst/tekst-persoonlijk-aangever/tekst-persoonlijk-aangever.component';
import {
    TekstPersoonlijkWijzigingBurgerlijkeStaatComponent
} from './income/toelichtingen-tekst/tekst-persoonlijk-wijzigingBurgerlijkeStaat/tekst-persoonlijk-wijzigingBurgerlijkeStaat.component';
import {
    TekstPersoonlijkKinderenComponent
} from './income/toelichtingen-tekst/tekst-persoonlijk-kinderen/tekst-persoonlijk-kinderen.component';
import {
    TekstWuoOndernemingComponent
} from './income/toelichtingen-tekst/tekst-wuo-onderneming/tekst-wuo-onderneming.component';
import {
    TekstWuoAdminKoppelenComponent
} from './income/toelichtingen-tekst/tekst-wuo-adminKoppelen/tekst-wuo-adminKoppelen.component';
import {
    TekstOndernemingVragenVoorafComponent
} from './income/toelichtingen-tekst/tekst-wuo-vragenVooraf/tekst-wuo-vragenVooraf.component';
import {
    TekstWuoResultatenrekeningComponent
} from './income/toelichtingen-tekst/tekst-wuo-resultatenrekening/tekst-wuo-resultatenrekening.component';
import {
    TekstWuoBalansActivaComponent
} from './income/toelichtingen-tekst/tekst-wuo-balansActiva/tekst-wuo-balansActiva.component';
import {
    TekstWuoBalansPassivaComponent
} from './income/toelichtingen-tekst/tekst-wuo-balansPassiva/tekst-wuo-balansPassiva.component';
import { TekstOndernemingPriveComponent } from './income/toelichtingen-tekst/tekst-wuo-prive/tekst-wuo-prive.component';
import {
    TekstOndernemingVermogensVergelijkingComponent
} from './income/toelichtingen-tekst/tekst-wuo-vermogensVergelijking/tekst-wuo-vermogensVergelijking.component';

import {
    SpecEindvermogenComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/vermogensvergelijking/spec-eindvermogen/spec-eindvermogen.component';
import {
    SpecBeginvermogenComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/vermogensvergelijking/spec-beginvermogen/spec-beginvermogen.component';
import {
    TekstOndernemingInvesteringenComponent
} from './income/toelichtingen-tekst/tekst-wuo-investeringen/tekst-wuo-investeringen.component';
import {
    TekstOndernemingWinstcorrectiesComponent
} from './income/toelichtingen-tekst/tekst-wuo-winstcorrecties/tekst-wuo-winstcorrecties.component';
import {
    TekstOaOndernemersaftrekComponent
} from './income/toelichtingen-tekst/tekst-oa-ondernemersaftrek/tekst-oa-ondernemersaftrek.component';
import {
    TekstOaMkbWinstvrijstellingComponent
} from './income/toelichtingen-tekst/tekst-oa-mkbWinstvrijstelling/tekst-oa-mkbWinstvrijstelling.component';
import {
    TekstLoonLoondienstComponent
} from './income/toelichtingen-tekst/tekst-loon-loondienst/tekst-loon-loondienst.component';
import {
    TekstLoonPensioenComponent
} from './income/toelichtingen-tekst/tekst-loon-pensioen/tekst-loon-pensioen.component';
import {
    TekstLoonBuitenlandComponent
} from './income/toelichtingen-tekst/tekst-loon-buitenland/tekst-loon-buitenland.component';
import {
    TekstLoonVrijgesteldComponent
} from './income/toelichtingen-tekst/tekst-loon-vrijgesteld/tekst-loon-vrijgesteld.component';
import {
    TekstLoonMeerBanenComponent
} from './income/toelichtingen-tekst/tekst-loon-meerBanen/tekst-loon-meerBanen.component';
import {
    TekstOverigInkomenRowComponent
} from './income/toelichtingen-tekst/tekst-overigInkomen-row/tekst-overigInkomen-row.component';
import {
    TekstOverigInkomenTbsComponent
} from './income/toelichtingen-tekst/tekst-overigInkomen-tbs/tekst-overigInkomen-tbs.component';
import {
    TekstOverigInkomenAlimentatieComponent
} from './income/toelichtingen-tekst/tekst-overigInkomen-alimentatie/tekst-overigInkomen-alimentatie.component';
import {
    TekstOverigInkomenPuComponent
} from './income/toelichtingen-tekst/tekst-overigInkomen-pu/tekst-overigInkomen-pu.component';
import {
    TekstWoningWoningenComponent
} from './income/toelichtingen-tekst/tekst-woning-woningen/tekst-woning-woningen.component';
import { TekstWoningEwsComponent } from './income/toelichtingen-tekst/tekst-woning-ews/tekst-woning-ews.component';
import {
    TekstWoningFinancieringskostenComponent
} from './income/toelichtingen-tekst/tekst-woning-financieringskosten/tekst-woning-financieringskosten.component';
import {
    TekstWoningRestschuldenComponent
} from './income/toelichtingen-tekst/tekst-woning-restschulden/tekst-woning-restschulden.component';
import {
    TekstWoningHuurinkomstenComponent
} from './income/toelichtingen-tekst/tekst-woning-huurinkomsten/tekst-woning-huurinkomsten.component';
import {
    TekstWoningOverigComponent
} from './income/toelichtingen-tekst/tekst-woning-overig/tekst-woning-overig.component';
import {
    TekstPremiesLijfrenteComponent
} from './income/toelichtingen-tekst/tekst-premies-lijfrente/tekst-premies-lijfrente.component';
import {
    TekstPremiesJaarruimteComponent
} from './income/toelichtingen-tekst/tekst-premies-jaarruimte/tekst-premies-jaarruimte.component';
import {
    TekstPremiesOverigComponent
} from './income/toelichtingen-tekst/tekst-premies-overig/tekst-premies-overig.component';
import {
    TekstPremiesTeruggaveComponent
} from './income/toelichtingen-tekst/tekst-premies-teruggave/tekst-premies-teruggave.component';
import { TekstAbInkomenComponent } from './income/toelichtingen-tekst/tekst-ab-inkomen/tekst-ab-inkomen.component';
import { TekstBox3BankComponent } from './income/toelichtingen-tekst/tekst-box3-bank/tekst-box3-bank.component';
import {
    TekstBox3BeleggingenComponent
} from './income/toelichtingen-tekst/tekst-box3-beleggingen/tekst-box3-beleggingen.component';
import {
    TekstBox3OnrZakenComponent
} from './income/toelichtingen-tekst/tekst-box3-onrZaken/tekst-box3-onrZaken.component';
import { TekstBox3OverigComponent } from './income/toelichtingen-tekst/tekst-box3-overig/tekst-box3-overig.component';
import {
    TekstBox3SchuldenComponent
} from './income/toelichtingen-tekst/tekst-box3-schulden/tekst-box3-schulden.component';
import { TekstPgaZorgComponent } from './income/toelichtingen-tekst/tekst-pga-zorg/tekst-pga-zorg.component';
import { TekstPgaGiftenComponent } from './income/toelichtingen-tekst/tekst-pga-giften/tekst-pga-giften.component';
import {
    TekstPgaScholingComponent
} from './income/toelichtingen-tekst/tekst-pga-scholing/tekst-pga-scholing.component';
import {
    TekstPgaOnderhoudComponent
} from './income/toelichtingen-tekst/tekst-pga-onderhoud/tekst-pga-onderhoud.component';
import { TekstPgaWeekendComponent } from './income/toelichtingen-tekst/tekst-pga-weekend/tekst-pga-weekend.component';
import { TekstPgaRestantComponent } from './income/toelichtingen-tekst/tekst-pga-restant/tekst-pga-restant.component';
import {
    TekstPgaNegatiefComponent
} from './income/toelichtingen-tekst/tekst-pga-negatief/tekst-pga-negatief.component';
import {
    TekstVoorheffingenVaComponent
} from './income/toelichtingen-tekst/tekst-voorheffingen-va/tekst-voorheffingen-va.component';
import {
    TekstVoorheffingenDivBelComponent
} from './income/toelichtingen-tekst/tekst-voorheffingen-divBel/tekst-voorheffingen-divBel.component';
import {
    TekstVoorheffingenBuitenlBronbelComponent
} from './income/toelichtingen-tekst/tekst-voorheffingen-buitenlBronbel/tekst-voorheffingen-buitenlBronbel.component';
import {
    TekstVoorheffingenLoonWinstComponent
} from './income/toelichtingen-tekst/tekst-voorheffingen-loonWinst/tekst-voorheffingen-loonWinst.component';
import { TekstVerrVerliesComponent } from './income/toelichtingen-tekst/tekst-verrVerlies/tekst-verrVerlies.component';
import { TekstVerdelingComponent } from './income/toelichtingen-tekst/tekst-verdeling/tekst-verdeling.component';
import { SharedUiBadgeModule } from '@snelstart/ui-badge';
import { SharedUiListPaneModule } from '@snelstart/ui-list-pane';
import {
    SpecVerliescompensatieComponent
} from './income/overzicht/verlies/spec-verliescompensatie/spec-verliescompensatie.component';
import {
    SnelstartVentureFiscaalFeatureTekstLoonReiskostenOvComponent
} from './income/toelichtingen-tekst/tekst-loon-reiskostenOv/snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv.component';
import {
    TekstPersoonlijkPartnerComponent
} from './income/toelichtingen-tekst/tekst-persoonlijk-partner/tekst-persoonlijk-partner.component';
import { PgaSamenvattingComponent } from './income/persoonsgebonden-aftrek/pga-samenvatting/pga-samenvatting.component';
import {
    Box2InkomenUitAanmerkelijkBelangSamenvattingComponent
} from './income/box2/box2-inkomen-uit-aanmerkelijk-belang.component';
import { SharedUiContextMenuModule } from '@snelstart/ui-context-menu';
import {
    BuitenlandseBronheffingComponent
} from './income/voorheffingen/buitenlandse-bronheffing/buitenlandse-bronheffing.component';
import {
    OverzichtNegInkomensvoorzieningComponent
} from './income/overzicht/box1/overzicht-neg-inkomensvoorziening/overzicht-neg-inkomensvoorziening.component';
import { OverzichtNegPgaComponent } from './income/overzicht/box1/overzicht-neg-pga/overzicht-neg-pga.component';
import { FeatureTaxCorporateDetailsModule } from '@snelstart-ventures/fiscaal/feature-tax-corporate-details';
import {
    SpecMachinesInstallatiesComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-machines-installaties/spec-machines-installaties.component';
import {
    SpecOverigMaterieleVasteActivaComponent
} from './income/box1/box1-winst-uit-onderneming/onderneming/balans/spec-overig-materiele-vaste-activa/spec-overig-materiele-vaste-activa.component';

@NgModule({
    imports: [
        CommonModule,
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        SharedUiIconModule,
        SharedUiOffCanvasModule,
        SharedUiButtonModule,
        SharedUiDialogModule,
        SharedFeatureNavigationBarModule,
        SharedUiTabModule,
        SharedUiTitleBarModule,
        SharedUiMainModule,
        SharedUiTableModule,
        SharedUiTooltipModule,
        SharedUiModule,
        FeatureTaxAllowanceListModule,
        FeatureTaxAllowanceDetailsModule,
        SharedUiLoadingModule,
        SharedUiAlertModule,
        SharedUiEntityHeaderModule,
        SharedUiPanelModule,
        SharedUiTooltipTriggerModule,
        TekstPersoonlijkAangeverComponent,
        TekstPersoonlijkWijzigingBurgerlijkeStaatComponent,
        TekstPersoonlijkKinderenComponent,
        TekstWuoOndernemingComponent,
        TekstWuoAdminKoppelenComponent,
        TekstOndernemingVragenVoorafComponent,
        TekstWuoResultatenrekeningComponent,
        TekstWuoBalansActivaComponent,
        TekstWuoBalansPassivaComponent,
        TekstOndernemingPriveComponent,
        TekstOndernemingVermogensVergelijkingComponent,
        TekstOndernemingInvesteringenComponent,
        TekstOndernemingWinstcorrectiesComponent,
        TekstOaOndernemersaftrekComponent,
        TekstOaMkbWinstvrijstellingComponent,
        TekstLoonLoondienstComponent,
        TekstLoonPensioenComponent,
        TekstLoonBuitenlandComponent,
        TekstLoonVrijgesteldComponent,
        TekstLoonVrijgesteldComponent,
        TekstLoonMeerBanenComponent,
        TekstOverigInkomenRowComponent,
        TekstOverigInkomenTbsComponent,
        TekstOverigInkomenAlimentatieComponent,
        TekstOverigInkomenPuComponent,
        TekstWoningWoningenComponent,
        TekstWoningEwsComponent,
        TekstWoningFinancieringskostenComponent,
        TekstWoningRestschuldenComponent,
        TekstWoningHuurinkomstenComponent,
        TekstWoningOverigComponent,
        TekstPremiesLijfrenteComponent,
        TekstPremiesJaarruimteComponent,
        TekstPremiesOverigComponent,
        TekstPremiesTeruggaveComponent,
        TekstAbInkomenComponent,
        TekstBox3BankComponent,
        TekstBox3BeleggingenComponent,
        TekstBox3OnrZakenComponent,
        TekstBox3OverigComponent,
        TekstBox3SchuldenComponent,
        TekstPgaZorgComponent,
        TekstPgaGiftenComponent,
        TekstPgaScholingComponent,
        TekstPgaOnderhoudComponent,
        TekstPgaWeekendComponent,
        TekstPgaRestantComponent,
        TekstPgaNegatiefComponent,
        TekstVoorheffingenVaComponent,
        TekstVoorheffingenDivBelComponent,
        TekstVoorheffingenBuitenlBronbelComponent,
        TekstVoorheffingenLoonWinstComponent,
        TekstVerrVerliesComponent,
        TekstVerdelingComponent,
        SharedUiBadgeModule,
        SharedUiListPaneModule,
        SnelstartVentureFiscaalFeatureTekstLoonReiskostenOvComponent,
        TekstPersoonlijkPartnerComponent,
        SharedUiContextMenuModule,
        FeatureTaxCorporateDetailsModule,
        SpecMachinesInstallatiesComponent,
        SpecOverigMaterieleVasteActivaComponent,
        FeatureTaxIncomeDetailsComponent,
        AangeverComponent,
        AangeverComponent,
        PartnerComponent,
        KindComponent,
        RelatiegegevensComponent,
        ApvLijstComponent,
        Box1BelastbareInkomstenOpBasisVanOvergangsrechtComponent,
        Box1NegatievePersoonsgebondenAftrekComponent,
        Box1NegatieveUitgavenVoorInkomensvoorzieningenComponent,
        Box2InkomenUitAanmerkelijkBelangComponent,
        Box3OwrComponent,
        Box3BankrekeningenComponent,
        Box3BeleggingsrekeningenComponent,
        Box3LeningenComponent,
        Box3NietVrijgesteldeKapitaalverzekeringenComponent,
        Box3OverigeBezittingenComponent,
        Box3OverigeOnroerendeZakenComponent,
        Box3OverigePeriodiekeUitkeringenComponent,
        Box3VorderingenOfContantGeldComponent,
        ConserverendInkomenComponent,
        HeffingskortingenComponent,
        PgaOnderhoudsverplichtingenComponent,
        PgaRestantPgaVoorgaandeJarenComponent,
        PgaScholingsuitgavenComponent,
        PgaSpecifiekeZorgkostenComponent,
        PgaSamenvattingComponent,
        PgaWeekenduitgavenGehandicapteKinderenComponent,
        PremieplichtComponent,
        VerdelingComponent,
        VertegenwoordigerComponent,
        VoorheffingenComponent,
        LoonBuitenlandComponent,
        LoonInternationaleOrganisatieComponent,
        LoonTegenwoordigComponent,
        LoonVroegerComponent,
        ReisaftrekOvComponent,
        EigenwoningRestschuldenComponent,
        EigenwoningSchuldenComponent,
        EigenwoningenComponent,
        AlimentatieComponent,
        PeriodiekeUitkeringenComponent,
        TbsRegelingComponent,
        ResultaatUitOverigeWerkzaamhedenComponent,
        LijfrentePremiesComponent,
        OverigePremiesComponent,
        OndernemerComponent,
        GewoneGiftenComponent,
        PeriodiekeGiftenComponent,
        BehandelkostenComponent,
        DietenComponent,
        ExtraUitgavenKledingEnBeddengoedComponent,
        HulpmiddelenComponent,
        KostenExtraGezinshulpComponent,
        MedicijnenComponent,
        ReiskostenEigenZorgComponent,
        ReiskostenZorgGezinslidComponent,
        Box1BelastbaarLoonComponent,
        Box1ResultaatOverigeWerkzaamhedenComponent,
        Box1BelastbarePeriodiekeUitkeringenEnVerstrekkingenComponent,
        Box1UitgavenVoorInkomensvoorzieningenComponent,
        Box1WinstUitOndernemingComponent,
        Box3SparenEnBeleggenComponent,
        Box3Component,
        PgaAftrekbareGiftenComponent,
        StudiefinancieringComponent,
        StudiefinancieringAangeverComponent,
        AanvullendeVragenComponent,
        IackInfoComponent,
        AanslagenComponent,
        VoorheffingenComponent,
        DividendbelastingBox2Component,
        DividendbelastingBox3Component,
        LoonOnderdeelWinstComponent,
        AlgemeenComponent,
        BalansComponent,
        InvesteringenComponent,
        WinstEnVerliesComponent,
        RapportComponent,
        Box1BelastbareInkomstenUitEigenwoningComponent,
        HeffingskortingenBerekeningenComponent,
        PersoonsgebondenAftrekBerekeningenComponent,
        OverzichtLoonComponent,
        OverzichtResultaatOverigeWerkzaamhedenComponent,
        OverzichtPeriodiekeUitkeringenComponent,
        OverzichtEigenWoningComponent,
        OverzichtLijfrenteComponent,
        OverzichtWinstUitOndernemingComponent,
        OverzichtJaarrekeningComponent,
        SpecPartnerschapComponent,
        SpecZorgkostenComponent,
        SpecGiftenComponent,
        SpecScholingComponent,
        OverzichtInkomenBox1Component,
        OverzichtInkomenBox2Component,
        OverzichtInkomenBox3Component,
        SpecBelastingBox3Component,
        SpecBelastingBox2Component,
        SpecBelastingBox1Component,
        SpecPremieVolksverzekeringenComponent,
        SpecHeffingskortingenComponent,
        SpecVoorheffingenComponent,
        OverzichtVerliescompensatieBox1Component,
        SpecOverigePgaComponent,
        UitlegAanslagComponent,
        PremiesAovComponent,
        PremiesAnwComponent,
        PremiesKindComponent,
        LijfrenteComponent,
        LijfrentePremiesComponent,
        JaarruimtegegevensComponent,
        BalansActivaComponent,
        BalansPassivaComponent,
        SpecOmzetbelastingActivaComponent,
        SpecHirComponent,
        SpecForComponent,
        SpecGebouwenEigenComponent,
        SpecGebouwenDerdenComponent,
        SpecOmzetbelastingPassivaComponent,
        AdministratieKoppelenIbComponent,
        VermogensvergelijkingComponent,
        SpecEindvermogenComponent,
        SpecBeginvermogenComponent,
        WinstcorrectiesComponent,
        VragenVoorafOndComponent,
        PriveOntrekkingenEnStortingenComponent,
        SpecEgalisatiereserveComponent,
        SpecGarantievoorzieningComponent,
        VoorlopigeAanslagenComponent,
        DividendbelastingComponent,
        VerrekenbareVerliezenComponent,
        HuurinkomstenComponent,
        HuurinkomstenComponent,
        OverigEigenWoningComponent,
        FinancieringskostenComponent,
        MeerBanenTegelijkComponent,
        BuitenlandseBronheffingTotaalComponent,
        OnverrekendeBuitenlandseBronheffingComponent,
        InkomstenbelastingComponent,
        ZorgverzekeringswetComponent,
        OverzichtVerliescompensatieBox1Component,
        OverzichtNegInkomensvoorzieningComponent,
        OverzichtNegPgaComponent,
        SpecVerliescompensatieComponent,
        Box2InkomenUitAanmerkelijkBelangSamenvattingComponent,
        BuitenlandseBronheffingComponent
    ],
    declarations: [],
    exports: [FeatureTaxIncomeDetailsComponent]
})
export class FeatureTaxIncomeDetailsModule {
}
